export default __webpack_public_path__ + "static/media/Leggings of the Swift Talon.55aac99c.jpg";